(function($) {
	// Prevent early clicks from missing required elements on slow page load
	$(
		function() {
			// Autoscroll "jump" links
			const contactJumpLinks = $( 'a[href="https://#scroll-to:contact-form"]' );

			// Contact form elements
			const contactForm = $( "#js-contact-form, .gform_confirmation_wrapper, .gform_validation_error" ).first();
			const contactFormInput = $( "#js-contact-form input" ).first();

			// Auto-scroll animation function for jump links
			contactJumpLinks.click(
				function(e) {
					e.preventDefault();
					scrollToContact();
				}
			);

			// Scroll to form on completion/error
			if ( $( ".gform_confirmation_wrapper" ).length > 0 || $( ".gform_validation_error" ).length > 0) {
				scrollToContact();
			}

			function scrollToContact() {
				/**
				* Use the site header as a 'useful' scroll offset (so the
				* contact form isn't flush with the top of the browser)
				*/
				let scrollOffset = $( "#masthead" ).outerHeight();

				// Define scroll destination
				let destination = contactForm.offset().top - scrollOffset;

				$( "html, body" ).animate(
					{
						scrollTop: destination
					},
					1500,
					"swing",
					function() {
						// Focus on first input once scrolling is complete
						contactFormInput.focus();
						return false;
					}
				);
			}
		}
	);
})( jQuery );
